import { StoreApi, UseBoundStore, useStore } from "zustand";
import {
  WecomContactsStoreType,
  wecomContactsStore,
} from "./wecom-contacts-store";
import {
  wecomContactsPersistentStore,
  WecomContactsPersistentStoreType,
} from "./wecom-contacts-persistent-store";

export const useWecomContactsStore = useStore.bind(
  null,
  wecomContactsStore.getStore()
) as UseBoundStore<StoreApi<WecomContactsStoreType>>;

export const useWecomContactsPersistentStore = useStore.bind(
  null,
  wecomContactsPersistentStore.getStore()
) as UseBoundStore<StoreApi<WecomContactsPersistentStoreType>>;
